import React, { useEffect, useState } from "react";
import { Radar } from "react-chartjs-2";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export default function RiskFactorAnalysis({ apiUrl = "/api/ncd/risk-factors" }) {
	const [data, setData] = useState(null);
	useEffect(() => {
		let mounted = true;
		(async () => {
			try {
				const res = await fetch(apiUrl, { cache: 'no-store' });
				if (!res.ok) throw new Error();
				const json = await res.json();
				if (!mounted) return;
				setData(json);
			} catch {
				setData({
					regions: ["Nashik", "Amravati", "Jalgoan", "Mumbai"],
					smokers: [18, 22, 15, 15],
					alcohol: [12, 10, 20, 18],
					obese: [24, 30, 18, 32]
				});
			}
		})();
		return () => mounted = false;
	}, [apiUrl]);

	const chartData = {
		labels: data?.regions || [],
		datasets: [
			{ label: "Smokers (%)", data: data?.smokers || [], backgroundColor: "rgba(245,54,92,0.15)", borderColor: "#f5365c" },
			{ label: "Alcohol (%)", data: data?.alcohol || [], backgroundColor: "rgba(17,205,239,0.12)", borderColor: "#11cdef" },
			{ label: "Obese (%)", data: data?.obese || [], backgroundColor: "rgba(45,206,137,0.12)", borderColor: "#2dce89" },
		]
	};
	const options = { maintainAspectRatio: false, responsive: true, scales: { r: { ticks: { color: "#525f7f" } } }, plugins: { datalabels: false, legend: { position: 'bottom' } } };

	return (
		<div className="card shadow-sm border-0 mt-3">
			<div className="card-body p-2">
				<h6 className="text-gray-800 font-semibold fs-6 mb-2">Risk Factor Analysis (by region)</h6>
				<div style={{ height: 480 }}><Radar data={chartData} options={options} /></div>
			</div>
		</div>
	);
}
